import { vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, createBlock as _createBlock, vModelText as _vModelText, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-xs-10 col-xs-offset-2"
}
const _hoisted_2 = { class: "checkbox" }
const _hoisted_3 = ["id", "name"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 2,
  class: "col-xs-10"
}
const _hoisted_7 = ["for"]
const _hoisted_8 = ["id", "name"]
const _hoisted_9 = ["id", "name"]
const _hoisted_10 = ["for"]
const _hoisted_11 = ["id", "name"]
const _hoisted_12 = ["id", "name"]
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 1,
  class: "col-sm-10"
}
const _hoisted_15 = ["id", "name"]
const _hoisted_16 = {
  key: 0,
  value: ""
}
const _hoisted_17 = ["value"]
const _hoisted_18 = ["id", "name"]
const _hoisted_19 = {
  key: 0,
  value: ""
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-sm-5" }
const _hoisted_22 = { class: "col-sm-5" }
const _hoisted_23 = ["value"]
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 3,
  class: "col-sm-10"
}
const _hoisted_26 = ["id", "value"]
const _hoisted_27 = ["id", "value"]
const _hoisted_28 = ["for"]
const _hoisted_29 = ["id", "name"]
const _hoisted_30 = ["id", "name"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["id", "name"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["id", "name"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { key: 3 }
const _hoisted_39 = ["id", "name", "title", "value"]
const _hoisted_40 = ["id", "name"]
const _hoisted_41 = ["id", "name"]
const _hoisted_42 = {
  key: 5,
  class: "col-sm-5"
}
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  key: 6,
  class: "col-sm-5"
}
const _hoisted_45 = {
  key: 7,
  class: "col-sm-5"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = {
  key: 3,
  class: "col-sm-10 col-sm-offset-2 help-block"
}
const _hoisted_49 = { class: "help-block" }
const _hoisted_50 = {
  key: 4,
  class: "col-sm-10 col-sm-offset-2 text-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plugin_prop_val = _resolveComponent("plugin-prop-val")!
  const _component_dynamic_form_plugin_prop = _resolveComponent("dynamic-form-plugin-prop")!
  const _component_pt_auto_complete = _resolveComponent("pt-auto-complete")!
  const _component_ace_editor_vue = _resolveComponent("ace-editor-vue")!
  const _component_ui_socket = _resolveComponent("ui-socket")!
  const _component_job_config_picker = _resolveComponent("job-config-picker")!
  const _component_key_storage_selector = _resolveComponent("key-storage-selector")!
  const _component_plugin_details = _resolveComponent("plugin-details")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.prop.type === 'Boolean')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.prop.defaultValue !== 'true')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (!_ctx.renderReadOnly)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        id: `${_ctx.rkey}prop_` + _ctx.pindex,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event)),
                        type: "checkbox",
                        name: `${_ctx.rkey}prop_` + _ctx.pindex,
                        value: "true"
                      }, null, 8, _hoisted_3)), [
                        [_vModelCheckbox, _ctx.currentValue]
                      ])
                    : _createCommentVNode("", true),
                  _createElementVNode("label", {
                    for: `${_ctx.rkey}prop_` + _ctx.pindex
                  }, _toDisplayString(_ctx.translatedTitle(_ctx.prop)), 9, _hoisted_4)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.prop.defaultValue === 'true')
            ? (_openBlock(), _createElementBlock("label", {
                key: 1,
                class: _normalizeClass(
          'col-sm-2 control-label input-sm ' + (_ctx.prop.required ? 'required' : '')
        ),
                for: `${_ctx.rkey}prop_` + _ctx.pindex
              }, _toDisplayString(_ctx.translatedTitle(_ctx.prop)), 11, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.prop.defaultValue === 'true')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("label", {
                  for: `${_ctx.rkey}prop_true_` + _ctx.pindex,
                  class: "radio-inline"
                }, [
                  (!_ctx.renderReadOnly)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        id: `${_ctx.rkey}prop_true_` + _ctx.pindex,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentValue) = $event)),
                        type: "radio",
                        name: `${_ctx.rkey}prop_` + _ctx.pindex,
                        value: "true"
                      }, null, 8, _hoisted_8)), [
                        [_vModelRadio, _ctx.currentValue]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        id: `${_ctx.rkey}prop_true_` + _ctx.pindex,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentValue) = $event)),
                        type: "radio",
                        name: `${_ctx.rkey}prop_` + _ctx.pindex,
                        value: "true",
                        disabled: true
                      }, null, 8, _hoisted_9)), [
                        [_vModelRadio, _ctx.currentValue]
                      ]),
                  _createVNode(_component_plugin_prop_val, {
                    prop: _ctx.prop,
                    value: 'true'
                  }, null, 8, ["prop"])
                ], 8, _hoisted_7),
                _createElementVNode("label", {
                  for: `${_ctx.rkey}prop_false_` + _ctx.pindex,
                  class: "radio-inline"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    id: `${_ctx.rkey}prop_false_` + _ctx.pindex,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentValue) = $event)),
                    type: "radio",
                    name: `${_ctx.rkey}prop_` + _ctx.pindex,
                    value: "false"
                  }, null, 8, _hoisted_11), [
                    [_vModelRadio, _ctx.currentValue]
                  ]),
                  _createVNode(_component_plugin_prop_val, {
                    prop: _ctx.prop,
                    value: 'false'
                  }, null, 8, ["prop"])
                ], 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_ctx.prop.options && _ctx.prop.options['displayType'] === 'DYNAMIC_FORM')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("input", {
              id: _ctx.rkey,
              type: "hidden",
              name: _ctx.prop.name
            }, null, 8, _hoisted_12),
            _createVNode(_component_dynamic_form_plugin_prop, {
              id: _ctx.rkey,
              modelValue: _ctx.currentValue,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentValue) = $event)),
              fields: _ctx.modelValue,
              "has-options": _ctx.hasAllowedValues(),
              options: _ctx.parseAllowedValues(),
              element: _ctx.rkey,
              name: _ctx.prop.name
            }, null, 8, ["id", "modelValue", "fields", "has-options", "options", "element", "name"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (!_ctx.prop.options || _ctx.prop.options['labelHidden'] !== 'true')
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  "data-testid": "plugin-prop-label",
                  class: _normalizeClass(
          'col-sm-2 control-label input-sm ' + (_ctx.prop.required ? 'required' : '')
        ),
                  for: `${_ctx.rkey}prop_` + _ctx.pindex
                }, _toDisplayString(_ctx.translatedTitle(_ctx.prop)), 11, _hoisted_13))
              : _createCommentVNode("", true),
            (_ctx.prop.type === 'Select')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (!_ctx.renderReadOnly)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        id: `${_ctx.rkey}prop_` + _ctx.pindex,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentValue) = $event)),
                        name: `${_ctx.rkey}prop_` + _ctx.pindex,
                        class: "form-control input-sm"
                      }, [
                        (!_ctx.prop.required)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_16, "--None Selected--"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prop.allowed, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: opt,
                            value: opt
                          }, [
                            _createVNode(_component_plugin_prop_val, {
                              prop: _ctx.prop,
                              value: opt
                            }, null, 8, ["prop", "value"])
                          ], 8, _hoisted_17))
                        }), 128))
                      ], 8, _hoisted_15)), [
                        [_vModelSelect, _ctx.currentValue]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 1,
                        id: `${_ctx.rkey}prop_` + _ctx.pindex,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentValue) = $event)),
                        name: `${_ctx.rkey}prop_` + _ctx.pindex,
                        class: "form-control input-sm",
                        disabled: true
                      }, [
                        (!_ctx.prop.required)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_19, "--None Selected--"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prop.allowed, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: opt,
                            value: opt
                          }, [
                            _createVNode(_component_plugin_prop_val, {
                              prop: _ctx.prop,
                              value: opt
                            }, null, 8, ["prop", "value"])
                          ], 8, _hoisted_20))
                        }), 128))
                      ], 8, _hoisted_18)), [
                        [_vModelSelect, _ctx.currentValue]
                      ])
                ]))
              : (_ctx.prop.type === 'FreeSelect')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_pt_auto_complete, {
                        modelValue: _ctx.currentValue,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentValue) = $event)),
                        suggestions: _ctx.inputTypeContextVariables,
                        "read-only": _ctx.renderReadOnly
                      }, null, 8, ["modelValue", "suggestions", "read-only"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (!_ctx.renderReadOnly)
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentValue) = $event)),
                            class: "form-control input-sm"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prop.allowed, (opt) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: opt,
                                value: opt
                              }, [
                                _createVNode(_component_plugin_prop_val, {
                                  prop: _ctx.prop,
                                  value: opt
                                }, null, 8, ["prop", "value"])
                              ], 8, _hoisted_23))
                            }), 128))
                          ], 512)), [
                            [_vModelSelect, _ctx.currentValue]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 1,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentValue) = $event)),
                            class: "form-control input-sm",
                            disabled: true
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prop.allowed, (opt) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: opt,
                                value: opt
                              }, [
                                _createVNode(_component_plugin_prop_val, {
                                  prop: _ctx.prop,
                                  value: opt
                                }, null, 8, ["prop", "value"])
                              ], 8, _hoisted_24))
                            }), 128))
                          ], 512)), [
                            [_vModelSelect, _ctx.currentValue]
                          ])
                    ])
                  ], 64))
                : (_ctx.prop.type === 'Options')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ longlist: _ctx.prop.allowed && _ctx.prop.allowed.length > 20 })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prop.allowed, (opt, oindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: opt,
                            class: "checkbox"
                          }, [
                            (!_ctx.renderReadOnly)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  id: `${_ctx.rkey}opt_` + _ctx.pindex + '_' + oindex,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentValue) = $event)),
                                  type: "checkbox",
                                  value: opt
                                }, null, 8, _hoisted_26)), [
                                  [_vModelCheckbox, _ctx.currentValue]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  id: `${_ctx.rkey}opt_` + _ctx.pindex + '_' + oindex,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentValue) = $event)),
                                  type: "checkbox",
                                  value: opt,
                                  disabled: true
                                }, null, 8, _hoisted_27)), [
                                  [_vModelCheckbox, _ctx.currentValue]
                                ]),
                            _createElementVNode("label", {
                              for: `${_ctx.rkey}opt_` + _ctx.pindex + '_' + oindex
                            }, [
                              _createVNode(_component_plugin_prop_val, {
                                prop: _ctx.prop,
                                value: opt
                              }, null, 8, ["prop", "value"])
                            ], 8, _hoisted_28)
                          ]))
                        }), 128))
                      ], 2)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: _normalizeClass(_ctx.inputColSize(_ctx.prop))
                    }, [
                      (['Integer', 'Long'].indexOf(_ctx.prop.type) >= 0 && !_ctx.renderReadOnly)
                        ? (_openBlock(), _createBlock(_component_pt_auto_complete, {
                            key: 0,
                            modelValue: _ctx.currentValue,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentValue) = $event)),
                            suggestions: _ctx.inputTypeContextVariables
                          }, null, 8, ["modelValue", "suggestions"]))
                        : (
            _ctx.prop.options && _ctx.prop.options['displayType'] === 'MULTI_LINE'
          )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!_ctx.renderReadOnly)
                                ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 0,
                                    id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentValue) = $event)),
                                    name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                    rows: "10",
                                    cols: "100",
                                    class: _normalizeClass(["form-control input-sm", _ctx.contextAutocomplete ? 'context_var_autocomplete' : ''])
                                  }, null, 10, _hoisted_29)), [
                                    [_vModelText, _ctx.currentValue]
                                  ])
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.currentValue) = $event)),
                                    name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                    rows: "10",
                                    cols: "100",
                                    class: "form-control input-sm",
                                    disabled: true
                                  }, null, 8, _hoisted_30)), [
                                    [_vModelText, _ctx.currentValue]
                                  ])
                            ], 64))
                          : (_ctx.prop.options && _ctx.prop.options['displayType'] === 'CODE')
                            ? (_openBlock(), _createBlock(_component_ui_socket, {
                                key: 2,
                                modelValue: _ctx.currentValue,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.currentValue) = $event)),
                                section: "plugin-prop-edit-textarea-code",
                                location: `property:${_ctx.prop.name}:${_ctx.prop.options ? _ctx.prop.options['CUSTOM_PROP_SOCKET_SECTION'] : ''}`
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ace_editor_vue, {
                                    id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                    modelValue: _ctx.currentValue,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.currentValue) = $event)),
                                    name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                    lang: _ctx.prop.options['codeSyntaxMode'],
                                    "code-syntax-selectable": 
                _ctx.prop.options['codeSyntaxSelectable'] === 'true' &&
                !_ctx.renderReadOnly
              ,
                                    height: "200",
                                    width: "100%",
                                    "read-only": _ctx.renderReadOnly,
                                    "context-variable-suggestions": _ctx.scriptTypeContextVariables,
                                    "min-lines": _ctx.aceEditorMinLines,
                                    "max-lines": _ctx.aceEditorMaxLines
                                  }, null, 8, ["id", "modelValue", "name", "lang", "code-syntax-selectable", "read-only", "context-variable-suggestions", "min-lines", "max-lines"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "location"]))
                            : (_ctx.prop.options && _ctx.prop.options['displayType'] === 'PASSWORD')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  (!_ctx.renderReadOnly)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _withDirectives(_createElementVNode("input", {
                                          id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentValue) = $event)),
                                          name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                          size: "100",
                                          type: "password",
                                          autocomplete: "new-password",
                                          class: "form-control input-sm"
                                        }, null, 8, _hoisted_32), [
                                          [_vModelText, _ctx.currentValue]
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _withDirectives(_createElementVNode("input", {
                                          id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currentValue) = $event)),
                                          name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                          size: "100",
                                          type: "password",
                                          autocomplete: "new-password",
                                          class: "form-control input-sm",
                                          disabled: true
                                        }, null, 8, _hoisted_34), [
                                          [_vModelText, _ctx.currentValue]
                                        ])
                                      ]))
                                ], 64))
                              : (
            _ctx.prop.options && _ctx.prop.options['displayType'] === 'STATIC_TEXT'
          )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    (_ctx.prop.options['staticTextContentType'] === 'text/html')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.prop.staticTextDefaultValue), 1))
                                      : (
              _ctx.prop.options['staticTextContentType'] === 'text/markdown'
            )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.prop.staticTextDefaultValue), 1))
                                        : (
              _ctx.prop.options['staticTextContentType'] ===
              'application/x-text-html-sanitized'
            )
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 2,
                                              innerHTML: _ctx.prop.staticTextDefaultValue
                                            }, null, 8, _hoisted_37))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.prop.staticTextDefaultValue), 1))
                                  ], 64))
                                : (
            _ctx.prop.options && _ctx.prop.options['displayType'] === 'RUNDECK_JOB'
          )
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 5,
                                      id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                      name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                      readonly: "",
                                      size: "100",
                                      class: "form-control input-sm",
                                      title: _ctx.currentValue,
                                      value: _ctx.jobName
                                    }, null, 8, _hoisted_39))
                                  : (_ctx.renderReadOnly)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 6,
                                        id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.currentValue) = $event)),
                                        name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                        size: "100",
                                        type: "text",
                                        class: "form-control input-sm",
                                        disabled: true
                                      }, null, 8, _hoisted_40)), [
                                        [_vModelText, _ctx.currentValue]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                        (_ctx.isAutoCompleteField)
                                          ? (_openBlock(), _createBlock(_component_pt_auto_complete, {
                                              key: 0,
                                              modelValue: _ctx.currentValue,
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.currentValue) = $event)),
                                              suggestions: _ctx.inputTypeContextVariables
                                            }, null, 8, ["modelValue", "suggestions"]))
                                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                                              key: 1,
                                              id: `${_ctx.rkey}prop_` + _ctx.pindex,
                                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.currentValue) = $event)),
                                              name: `${_ctx.rkey}prop_` + _ctx.pindex,
                                              size: "100",
                                              type: "text",
                                              class: _normalizeClass(["form-control input-sm", _ctx.contextAutocomplete ? 'context_var_autocomplete' : ''])
                                            }, null, 10, _hoisted_41)), [
                                              [_vModelText, _ctx.currentValue]
                                            ])
                                      ], 64))
                    ], 2)),
            (
          _ctx.prop.options && _ctx.prop.options['selectionAccessor'] === 'PLUGIN_TYPE'
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.currentValue) = $event)),
                    class: "form-control input-sm"
                  }, [
                    _cache[26] || (_cache[26] = _createElementVNode("option", {
                      disabled: "",
                      value: ""
                    }, "-- Select Plugin Type --", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectorDataForName, (opt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: opt.key,
                        value: opt.value
                      }, _toDisplayString(opt.key), 9, _hoisted_43))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.currentValue]
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.prop.options && _ctx.prop.options['selectionAccessor'] === 'RUNDECK_JOB'
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createVNode(_component_job_config_picker, {
                    modelValue: _ctx.currentValue,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.currentValue) = $event)),
                    "btn-class": `btn-primary`
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.prop.options && _ctx.prop.options['selectionAccessor'] === 'STORAGE_PATH'
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  (_ctx.useRunnerSelector === true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createVNode(_component_ui_socket, {
                          section: "plugin-runner-key-selector",
                          location: "nodes",
                          "event-bus": _ctx.eventBus,
                          "socket-data": {
              storageFilter: _ctx.prop.options['storage-file-meta-filter'],
              allowUpload: true,
              readOnly: _ctx.renderReadOnly,
              value: _ctx.currentValue,
              handleUpdate: (val) => (_ctx.currentValue = val),
            }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_key_storage_selector, {
                              modelValue: _ctx.currentValue,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.currentValue) = $event)),
                              "storage-filter": _ctx.prop.options['storage-file-meta-filter'],
                              "allow-upload": true,
                              "read-only": _ctx.renderReadOnly
                            }, null, 8, ["modelValue", "storage-filter", "read-only"])
                          ]),
                          _: 1
                        }, 8, ["event-bus", "socket-data"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createVNode(_component_key_storage_selector, {
                          modelValue: _ctx.currentValue,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.currentValue) = $event)),
                          "storage-filter": _ctx.prop.options['storage-file-meta-filter'],
                          "allow-upload": true,
                          "read-only": _ctx.renderReadOnly
                        }, null, 8, ["modelValue", "storage-filter", "read-only"])
                      ]))
                ]))
              : (_ctx.prop.options && _ctx.prop.options['selectionAccessor'])
                ? _renderSlot(_ctx.$slots, "accessors", {
                    key: 8,
                    prop: _ctx.prop,
                    inputValues: _ctx.inputValues,
                    accessor: _ctx.prop.options['selectionAccessor']
                  }, undefined, true)
                : _createCommentVNode("", true)
          ], 64)),
    (_ctx.prop.desc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createVNode(_component_plugin_details, {
            description: _ctx.translatedDesc(_ctx.prop),
            "extended-css": _ctx.extendedCss,
            "description-css": "more-info",
            "markdown-container-css": "m-0 p-0",
            "inline-description": "",
            "allow-html": ""
          }, {
            extraDescriptionText: _withCtx(() => [
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.translatedDesc(_ctx.prop)), 1)
            ]),
            _: 1
          }, 8, ["description", "extended-css"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.validation && !_ctx.validation.valid && _ctx.validation.errors[_ctx.prop.name])
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.validation.errors[_ctx.prop.name]), 1))
      : _createCommentVNode("", true)
  ]))
}